import { render, staticRenderFns } from "./Line-Item-V2.vue?vue&type=template&id=34e096be&scoped=true"
import script from "./Line-Item-V2.vue?vue&type=script&lang=js"
export * from "./Line-Item-V2.vue?vue&type=script&lang=js"
import style0 from "./Line-Item-V2.vue?vue&type=style&index=0&id=34e096be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e096be",
  null
  
)

export default component.exports